import React, { forwardRef, useMemo } from 'react';
import AnimatedSvg from './components/AnimatedSvg';
import { addAttributesToStringSvg } from './utils';
import classNames from 'classnames';
import styles from './AnimatedIcon.module.scss';
import { useDefaultHoverBehavior } from './useDefaultHoverBehavior';
import type { AnimatedSvgRef, AnimatedIconBuilderProps } from './types';
import { DEFAULT_ANIMATION_DURATION } from './constants';

export type { AnimatedIconBuilderProps as AnimatedIconProps } from './types';

const AnimatedIcon = forwardRef<AnimatedSvgRef, AnimatedIconBuilderProps>(
  (props, ref) => {
    const {
      svg,
      duration = DEFAULT_ANIMATION_DURATION,
      className,
      id,
      'data-testid': dataTestId,
      reducedMotion,
    } = props;
    const svgContent = svg?.svgContent;

    const processedSvg = useMemo(
      () => addAttributesToStringSvg(svgContent || '', duration),
      [svgContent, duration],
    );

    const { actualRef, ...mouseEventProps } = useDefaultHoverBehavior(ref);

    if (svgContent) {
      return (
        <div
          className={classNames(
            styles.animatedIcon,
            'animatedIcon',
            'icon',
            className,
          )}
          id={id}
          data-testid={dataTestId}
          {...mouseEventProps}
        >
          <AnimatedSvg
            ref={actualRef}
            svgContent={processedSvg}
            reducedMotion={reducedMotion}
            duration={duration}
          />
        </div>
      );
    }

    return null;
  },
);

export default AnimatedIcon;
